import React from "react";

interface ReferralCreditSummaryProps {
	creditsEarned: number;
	creditsPending: number;
	referralNames: string[];
}

const ReferralCreditSummary: React.FC<ReferralCreditSummaryProps> = ({
	creditsEarned,
	creditsPending,
	referralNames
}) => {
	const totalAtRisk = creditsEarned + creditsPending;
	const displayNames =
		referralNames.slice(0, 5).join(", ") +
		(referralNames.length > 5 ? ", ..." : "");

	return (
		<div className="bg-primary-accent border border-primary-inactive rounded-lg p-4">
			<h4 className="text-primary-active font-bold text-center mb-3">
				Your Referral Credits
			</h4>
			<div className="border-t border-primary-inactive pt-3 space-y-2">
				<div className="flex justify-between">
					<span className="text-primary-active text-sm">Credits earned</span>
					<span className="text-primary-active text-sm font-bold">
						{creditsEarned}
					</span>
				</div>
				<div className="flex justify-between">
					<span className="text-primary-active text-sm">
						Credits pending (future renewals)
					</span>
					<span className="text-primary-active text-sm font-bold">
						{creditsPending}
					</span>
				</div>
				{referralNames.length > 0 && (
					<p className="text-primary-active text-xs pl-4">{displayNames}</p>
				)}
			</div>
			<div className="border-t border-primary-inactive mt-3 pt-3">
				<div className="flex justify-between items-baseline">
					<span className="text-2xl font-bold text-error-active">
						Total at Risk
					</span>
					<div className="text-right">
						<span className="text-2xl font-bold text-error-active">
							{totalAtRisk}
						</span>
						<p className="text-xs text-error-active">credits</p>
					</div>
				</div>
			</div>
		</div>
	);
};

ReferralCreditSummary.displayName = "ReferralCreditSummary";

export default ReferralCreditSummary;
export type { ReferralCreditSummaryProps };
